export interface SocialMonthlyData {
  id: string
  brand: 'Toyota' | 'Lexus'
  market: string
  year: string
  month: string
  platform: 'Instagram' | 'Facebook' | 'TikTok' | 'LinkedIn'
  contentType: 'Brand' | 'Tactical' | 'Value chain'
  engagementRate: number
  reach: number
  posts: number
  followers: number
  followerGrowth: number
  totalViews: number
}

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]
const platforms: SocialMonthlyData['platform'][] = [
  'Instagram',
  'Facebook',
  'TikTok',
  'YouTube',
  'LinkedIn',
]
const contentTypes: SocialMonthlyData['contentType'][] = [
  'Brand',
  'Tactical',
  'Value chain',
]
const markets = ['SLO', 'CRO', 'RS', 'BiH', 'MNE']

const generateSocialData = (): SocialMonthlyData[] => {
  const data: SocialMonthlyData[] = []
  let id = 1

  const brands: ('Toyota' | 'Lexus')[] = ['Toyota', 'Lexus']
  const years = ['2023', '2024', '2025', '2026']

  brands.forEach((brand) => {
    markets.forEach((market) => {
      years.forEach((year) => {
        months.forEach((month, monthIdx) => {
          platforms.forEach((platform) => {
            const contentType =
              contentTypes[Math.floor(Math.random() * contentTypes.length)]

            const baseEngagement = brand === 'Toyota' ? 3.5 : 4.2
            const platformMultiplier =
              platform === 'Instagram'
                ? 1.3
                : platform === 'TikTok'
                  ? 1.5
                  : platform === 'Facebook'
                    ? 0.8
                    : platform === 'LinkedIn'
                      ? 0.6
                      : 1.0
            const engagementRate =
              baseEngagement * platformMultiplier +
              Math.random() * 2 -
              1 +
              monthIdx * 0.05

            const baseReach = brand === 'Toyota' ? 45000 : 32000
            const reachMultiplier =
              platform === 'TikTok'
                ? 2.5
                : platform === 'Instagram'
                  ? 1.4
                  : platform === 'YouTube'
                    ? 1.8
                    : platform === 'LinkedIn'
                      ? 0.5
                      : 1.0
            const reach = Math.floor(
              baseReach *
                reachMultiplier *
                (1 + Math.random() * 0.4) *
                (1 + monthIdx * 0.02),
            )

            const basePosts = contentType === 'Brand' ? 8 : 12
            const posts = Math.floor(basePosts + Math.random() * 6)

            const baseFollowers =
              platform === 'Instagram'
                ? brand === 'Toyota'
                  ? 125000
                  : 85000
                : platform === 'Facebook'
                  ? brand === 'Toyota'
                    ? 180000
                    : 120000
                  : platform === 'TikTok'
                    ? brand === 'Toyota'
                      ? 65000
                      : 42000
                    : platform === 'YouTube'
                      ? brand === 'Toyota'
                        ? 95000
                        : 60000
                      : brand === 'Toyota'
                        ? 45000
                        : 30000 // LinkedIn
            const yearMultiplier = parseInt(year) - 2023
            const followers = Math.floor(
              baseFollowers * (1 + yearMultiplier * 0.15 + monthIdx * 0.01),
            )

            const followerGrowth = 1.5 + Math.random() * 2.5 + monthIdx * 0.1

            // TikTok has totalViews, others get 0
            const baseTotalViews = brand === 'Toyota' ? 350000 : 220000
            const totalViews =
              platform === 'TikTok'
                ? Math.floor(
                    baseTotalViews *
                      (1 + Math.random() * 0.5) *
                      (1 + monthIdx * 0.03 + yearMultiplier * 0.2),
                  )
                : 0

            data.push({
              id: `social-${id++}`,
              brand,
              market,
              year,
              month,
              platform,
              contentType,
              engagementRate: Math.max(0.5, Math.min(10, engagementRate)),
              reach,
              posts,
              followers,
              followerGrowth: Math.max(0, Math.min(8, followerGrowth)),
              totalViews,
            })
          })
        })
      })
    })
  })

  return data
}

export const allSocialData = generateSocialData()
